import { appStore } from '@/store';
import { features, logger } from '@/lib';
import type { FormState } from '@/store/models/form/types';

/* === Begin Types === */
type CrsState = Pick<FormState, 'crsTaxDetails'>;
/* === End Types === */

const getCrsState = (formState: FormState): CrsState => {
  const { crsTaxDetails } = formState;
  return {
    crsTaxDetails,
  };
};

const isEligibleForCRS = (): boolean => {
  const { form: formState } = appStore.getState();
  const { onboardOption } = formState;
  const isSignup = onboardOption.value === 'signup';

  return isSignup && features.isActive('shouldShowCRSTaxCollectionSection');
};

/**
 * @function shouldShowCRSInterstitial
 * @description validates if the onboard option is singup,
 * the CRS Treatment is active and that the user hasnt filled this already
 * @returns {Boolean} show or not the interstitial
 *
 *
 */
const shouldShowCRSInterstitial = (): boolean => {
  const { form: formState } = appStore.getState();
  const { bypassCRSInterstitial } = formState;
  if (isEligibleForCRS() && !bypassCRSInterstitial) {
    const logMessage = 'display_crs_interstitial';
    logger.info(logMessage);
    const { ui: uiActions } = appStore.getActions();
    uiActions.toggleIsCRSInterstitialOpen(true);
    return false;
  }

  return false;
};

export { getCrsState, isEligibleForCRS, shouldShowCRSInterstitial };
